$(document).on('submit', 'form[data-loading-text]', function () {
	let $form = $(this),
		text = $form.data('loading-text'),
		$btn = $(this).find('button[type=submit]');

	$btn.text(text).attr('disabled', 'disabled');
});

//
$(document).on('change', 'select[data-vg-toggle="select"]', function () {
	let option = this.options[this.selectedIndex],
		nSelect = this.nextSibling,
		nSelectCurrent = nSelect.querySelector('.current');

	nSelectCurrent.innerHTML = nSelect.querySelector('.option[data-value="'+ option.getAttribute('value') +'"]').innerHTML;
});

